import { Bar, Line } from 'react-chartjs-2'
import { Grid } from '@material-ui/core'

import Card from 'src/components/sharedComponents/Card/Card'
import CardBody from 'src/components/sharedComponents/Card/CardBody'
import CardHeader from 'src/components/sharedComponents/Card/CardHeader'
import * as Utils from 'src/utils/chartsUtils'
import { useStyles } from '../styles'
import TableIndustry from '../../Tables/TableIndustry'

const TotalIndustryCard = props => {
  const {
    totalIndustry = [],
    selectedDate,
    gTotalIndustry,
    gTotalIndustryA,
    gTotalIndustryB,
  } = props
  const classes = useStyles()

  return (
    <Card>
      <CardHeader>
        <div className={classes.center}>
          <div>
            <h3>Total Industria</h3>
          </div>
          {`  `}
        </div>
      </CardHeader>
      <CardBody>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} lg={6}>
            <TableIndustry array={totalIndustry} selectedDate={selectedDate} param="EMPRESA" />
          </Grid>
          <Grid item xs={12} sm={12} lg={6}>
            <h3>Evolución del mercado total en miles</h3>
            <br />
            <Bar
              data={Utils.customBarLineDataGroup(gTotalIndustry, 'EMPRESA', 'CANT', 'y', '1')}
              options={Utils.optionsSimpleBarChart}
            />{' '}
          </Grid>
          <Grid item xs={12} sm={12} lg={6}>
            <h3>Participación de mercado en unidades – mes</h3>
            <br />
            <Line
              data={Utils.customBarLineDataGroup(gTotalIndustryB, 'EMPRESA', 'PORC', 'MES', '100')}
              options={Utils.optionsLine}
            />{' '}
          </Grid>
          <Grid item xs={12} sm={12} lg={6}>
            <h3>Participación de mercado en unidades – año</h3>
            <br />
            <Line
              data={Utils.customBarLineDataGroup(gTotalIndustryA, 'EMPRESA', 'PORCENTAJE', 'y', '100')}
              options={Utils.optionsLine}
            />{' '}
          </Grid>
        </Grid>
      </CardBody>
    </Card>
  )
}

export default TotalIndustryCard
